/**
 * 判断目标是否为函数
 */
export function isCallable<P extends unknown[], R = React.ReactNode>(
  target: R | ((...args: P) => R),
): target is (...args: P) => R {
  return typeof target === 'function';
}

/**
 * 处理 `R | (...args) => R` 类似类型
 */
export function injectValue<P extends unknown[], R = React.ReactNode>(
  target: R | ((...args: P) => R),
) {
  return (...args: P) => (isCallable(target) ? target(...args) : target);
}

/**
 * 改写大驼峰：close-fill -> CloseFill
 */
export function toPascalCase(str: string): string {
  return str
    .split('-')
    .map(item => item.replace(/^([a-z])/, x => x.toUpperCase()))
    .join('');
}

/**
 * 判断子节点类型
 */
export function isChildOfType(child: React.ReactNode, type: React.ElementType): boolean {
  if (typeof child === 'undefined' || child === null) return false;
  if (typeof child === 'string' || typeof child === 'number') return false;
  if (React.isValidElement(child)) {
    if (typeof type === 'string') {
      return child.type === type;
    }
    return child.type === React.createElement(type, {}).type;
  }
  return false;
}

import React from 'react';
